import { SABRE_BEDBANK_SUPPLIER_CODE } from 'constants/bedbank'
import { ELIGIBLE_FOR_HOTEL_LOYALTY_POINTS_INCLUSION_DESCRIPTION } from 'lib/search/constants'

export function getBedbankSupplierCode(rate: {
  supplierCode?: string
  bedbankSupplierCode?: string
}): string | undefined {
  return rate.supplierCode ?? rate.bedbankSupplierCode
}

export function isSabreBedbankSupplier(supplierCode?: string): boolean {
  return supplierCode === SABRE_BEDBANK_SUPPLIER_CODE
}

export function hasHotelLoyaltyPointsInclusion(
  inclusions?: Array<{ description: string }>,
): boolean {
  return inclusions?.some(
    inclusion => inclusion.description === ELIGIBLE_FOR_HOTEL_LOYALTY_POINTS_INCLUSION_DESCRIPTION,
  ) ?? false
}

export function isBedbankRateEligibleForHotelLoyaltyProgram(
  rate: {
    supplierCode?: string
    bedbankSupplierCode?: string
    inclusions?: Array<{ description: string }>
  },
  isFeatureFlagEnabled: boolean,
): boolean {
  if (!isFeatureFlagEnabled) {
    return false
  }

  const supplierCode = getBedbankSupplierCode(rate)

  return isSabreBedbankSupplier(supplierCode) && hasHotelLoyaltyPointsInclusion(rate.inclusions)
}
